import getPageComponent from 'common/routes/getPageComponent';
import {
  ACCOUNT_CPL_PATH,
  ACCOUNT_DASHBOARD_PATH,
  ACCOUNT_MODELS_PATH,
  ACCOUNT_PATH,
  ACCOUNT_PAYOUTS_PATH,
  ACCOUNT_REFERRALS_PATH,
  ACCOUNT_SETTINGS_PATH,
  ACCOUNT_STATISTICS_PATH,
  DOCUMENTATION_PATH,
  LIBRARY_BANNERS_PATH,
  LIBRARY_LANDING_PAGE_BUILDER,
  LIBRARY_LINKS_BUILDER_PATH,
  LIBRARY_PATH,
  LIBRARY_POPUNDERS_PATH,
  LIBRARY_PRE_ROLLS_PATH,
  LIBRARY_SMART_POPUNDERS_LIST_PATH,
  LIBRARY_WHITE_LABELS_PATH,
  LIBRARY_WIDGETS_PATH,
  NEWS_ITEM_PATH,
  NEWS_PATH,
  PAYOUT_SETTINGS_PATH,
  POSTBACK_SETTINGS_PATH,
  POSTBACKS_DOCUMENTATION_PATH,
  POSTBACKS_LOG_PATH,
  SECRETS_SETTINGS_PATH,
  SERVICE_POSTBACK_PARAMS_PATH,
  SETTINGS_PATH,
} from 'common/selectors/sidebar';
import {
  ENTITY_ID,
  MAYBE_ENTITY_ID,
  PAGINATION,
} from 'common/routes/constants';
import redirects from 'common/routes/redirects';
import {
  ANALYTICS_MEMBER_INSPECTOR_PATH,
  DOCUMENTATION_LANDING_OPTIONS_PATH,
  DOCUMENTATION_MODELS_LIST_PATH,
  DOCUMENTATION_SCRIPTS_PATH,
  DOCUMENTATION_TRACK_URL_PATH,
  EARNINGS_LOG_PATH,
  EASY_LINKS_PATH,
  LINKS_AD_CREATIVES_BUILDER_PATH,
  LINKS_BANNERS_PATH,
  LINKS_CREATIVES_BUILDER_PATH,
  LINKS_LINKS_BUILDER_PATH,
  LINKS_POPUNDERS_PATH,
  LINKS_PRE_ROLLS_PATH,
  LINKS_SMART_LINK_PATH,
  LINKS_SMART_LINKS_PATH,
  LINKS_WIDGETS_PATH,
  MODELS_TRAFFIC_PATH,
  OVERVIEW_ACCOUNT_PATH,
  OVERVIEW_CPL_PATH,
  OVERVIEW_DASHBOARD_PATH,
  PAYOUTS_HISTORY_PATH,
  PAYOUTS_PAYOUT_HISTORY_PATH,
  PAYOUTS_PAYOUTS_SETUP_PATH,
  PAYOUTS_SETUP_PATH,
  REFERRAL_PROGRAM_REFERRALS_PATH,
  SERVICE_POSTBACK_SETUP_PATH,
  SERVICE_SECRETS_PATH,
} from 'common/selectors/sidebar/affiliates';
import {
  // PLOP_APPEND_PAGE_ROUTE_IMPORT_PATTERN
  ANALYTICS_CATEGORY_PATH,
  ANALYTICS_STATISTICS_PATH,
  DOCUMENTATION_API_PATH,
  DOCUMENTATION_CATEGORY_PATH,
  DOCUMENTATION_LINKS_CREATIVES_PARAMS_PATH,
  DOCUMENTATION_MODELS_AGGREGATORS_SWAGGER_PATH,
  DOCUMENTATION_POSTBACK_PARAMS_PATH,
  DOCUMENTATION_VIDEO_TUTORIALS_PATH,
  LINKS_CATEGORY_PATH,
  OVERVIEW_CATEGORY_PATH,
  OVERVIEW_NEWS_ITEM_PATH,
  OVERVIEW_NEWS_PATH,
  PAYOUTS_CATEGORY_PATH,
  REFERRAL_PROGRAM_AFFILIATES_PATH,
  REFERRAL_PROGRAM_CATEGORY_PATH,
  REFERRAL_PROGRAM_MODELS_DEP_PATH,
  REFERRAL_PROGRAM_MODELS_PATH,
  SERVICE_API_DOMAIN_PATH,
  SERVICE_CATEGORY_PATH,
  SERVICE_POSTBACK_LOG_PATH,
  SERVICE_POSTBACKS_LOG_PATH,
  WHITE_LABELS_CATEGORY_PATH,
} from 'common/selectors/sidebar/common';
import {
  any,
  commonAccessForStripchatScheme,
  internalSchemesToForbidden,
  mediaBuyerStudioOrModelToModelsTraffic,
  notApprovedToAccount,
  notLoggedToLogin,
  notMediaBuyerStudioOrModelToDashboard,
  notPPStoForbiddenMemberInspector,
  onlyAffiliatesWithStripchatScheme,
  onlyRegularAffiliates,
  smartLinkAccess,
  whiteLabelAccess,
  withAclToForbidden,
  withoutAclToForbidden,
} from 'common/helpers/routesAccess';

const PAGES = {
  // PLOP_APPEND_PAGE_COMPONENT_IMPORT_PATTERN
  ModelsTraffic: () => import('affiliates/pages/ModelsTrafficPage'),
  AccountSettings: () => import('affiliates/pages/AccountSettingsPage'),
  CreatviesDocumentation: () =>
    import('common/pages/CreativesDocumentationPage'),
  Banners: () => import('affiliates/pages/BannersPage'),
  PreRollsAds: () => import('affiliates/pages/PreRollsAdsPage'),
  Cpl: () => import('affiliates/pages/CplPage'),
  Dashboard: () => import('affiliates/pages/DashboardPage'),
  LinksBuilder: () => import('affiliates/pages/LinksBuilderPage'),
  Models: () => import('affiliates/pages/ModelsPage'),
  NewsPage: () => import('affiliates/pages/NewsPage'),
  PayoutSettings: () => import('affiliates/pages/PayoutSettingsPage'),
  PayoutHistory: () => import('affiliates/pages/PayoutHistoryPage'),
  LandingPageBuilder: () => import('common/pages/LandingPageBuilder'),
  PostbacksDocumentation: () =>
    import('affiliates/pages/PostbacksDocumentationPage'),
  PostbackSettings: () => import('affiliates/pages/PostbackSettingsPage'),
  Referrals: () => import('affiliates/pages/ReferralsPage'),
  SmartPopundersItem: () => import('common/pages/SmartPopunderPage'),
  SmartPopundersList: () => import('common/pages/SmartPopundersPage'),
  Statistics: () => import('affiliates/pages/StatisticsPage'),
  MemberInspector: () => import('affiliates/pages/MemberInspector'),
  LandingOptionsDocumentation: () =>
    import('affiliates/pages/LandingOptionsDocumentationPage'),
  ApiDocumentation: () => import('common/pages/ApiDocumentationPage'),
  ScriptsDocumentation: () =>
    import('affiliates/pages/ScriptsDocumentationPage'),
  WhiteLabel: () => import('affiliates/pages/WhiteLabelPage'),
  VideoTutorials: () => import('common/pages/VideoTutorialsPage'),
  WhiteLabels: () => import('affiliates/pages/WhiteLabelsPage'),
  PostbacksLogs: () => import('common/pages/PostbacksLogsPage'),
  Secrets: () => import('affiliates/pages/SecretsPage'),
  ApiForDomain: () => import('affiliates/pages/ApiForDomainPage'),
  EasyLinks: () => import('affiliates/pages/EasyLinksPage'),
  EarningsLog: () => import('affiliates/pages/EarningsLogPage'),
};

const MAIN_LAYOUT_ROUTES = [
  ...redirects({
    [ACCOUNT_PATH]: OVERVIEW_DASHBOARD_PATH,
    [ACCOUNT_DASHBOARD_PATH]: OVERVIEW_DASHBOARD_PATH,
    [ACCOUNT_STATISTICS_PATH]: ANALYTICS_STATISTICS_PATH,
    [ANALYTICS_CATEGORY_PATH]: ANALYTICS_STATISTICS_PATH,
    [LIBRARY_PATH]: LINKS_BANNERS_PATH,
    [LIBRARY_BANNERS_PATH]: LINKS_BANNERS_PATH,
    [LIBRARY_LINKS_BUILDER_PATH]: LINKS_LINKS_BUILDER_PATH,
    [LIBRARY_PRE_ROLLS_PATH]: LINKS_PRE_ROLLS_PATH,
    [LIBRARY_WIDGETS_PATH]: LINKS_WIDGETS_PATH,
    [LIBRARY_POPUNDERS_PATH]: LINKS_POPUNDERS_PATH,
    [ACCOUNT_SETTINGS_PATH]: OVERVIEW_ACCOUNT_PATH,
    [SETTINGS_PATH]: OVERVIEW_ACCOUNT_PATH,
    [PAYOUT_SETTINGS_PATH]: PAYOUTS_PAYOUTS_SETUP_PATH,
    [PAYOUTS_SETUP_PATH]: PAYOUTS_PAYOUTS_SETUP_PATH,
    [POSTBACK_SETTINGS_PATH]: SERVICE_POSTBACK_SETUP_PATH,
    [SECRETS_SETTINGS_PATH]: SERVICE_SECRETS_PATH,
    [DOCUMENTATION_PATH]: DOCUMENTATION_LANDING_OPTIONS_PATH,
    [DOCUMENTATION_TRACK_URL_PATH]: DOCUMENTATION_LANDING_OPTIONS_PATH,
    [`${DOCUMENTATION_MODELS_LIST_PATH}*`]:
      DOCUMENTATION_MODELS_AGGREGATORS_SWAGGER_PATH,
    [POSTBACKS_DOCUMENTATION_PATH]: DOCUMENTATION_POSTBACK_PARAMS_PATH,
    [SERVICE_POSTBACK_PARAMS_PATH]: DOCUMENTATION_POSTBACK_PARAMS_PATH,
    [`${ACCOUNT_MODELS_PATH}*`]: REFERRAL_PROGRAM_MODELS_PATH,
    [`${ACCOUNT_PAYOUTS_PATH}*`]: PAYOUTS_PAYOUT_HISTORY_PATH,
    [`${PAYOUTS_HISTORY_PATH}*`]: PAYOUTS_PAYOUT_HISTORY_PATH,
    [`${ACCOUNT_REFERRALS_PATH}*`]: REFERRAL_PROGRAM_AFFILIATES_PATH,
    [`${ACCOUNT_CPL_PATH}*`]: OVERVIEW_CPL_PATH,
    [`${LIBRARY_SMART_POPUNDERS_LIST_PATH}*`]: LINKS_SMART_LINK_PATH,
    [`${LINKS_SMART_LINKS_PATH}*`]: LINKS_SMART_LINK_PATH,
    [`${LIBRARY_LANDING_PAGE_BUILDER}*`]: LINKS_AD_CREATIVES_BUILDER_PATH,
    [`${LINKS_CREATIVES_BUILDER_PATH}*`]: LINKS_AD_CREATIVES_BUILDER_PATH,
    [`${LIBRARY_WHITE_LABELS_PATH}*`]: WHITE_LABELS_CATEGORY_PATH,
    [`${NEWS_PATH}*`]: OVERVIEW_NEWS_PATH,
    [`${NEWS_ITEM_PATH}*`]: OVERVIEW_NEWS_ITEM_PATH,
    [`${POSTBACKS_LOG_PATH}*`]: SERVICE_POSTBACKS_LOG_PATH,
    [`${SERVICE_POSTBACK_LOG_PATH}*`]: SERVICE_POSTBACKS_LOG_PATH,
    [`${LINKS_POPUNDERS_PATH}*`]: LINKS_AD_CREATIVES_BUILDER_PATH,
    [`${LINKS_WIDGETS_PATH}*`]: LINKS_AD_CREATIVES_BUILDER_PATH,
    [`${REFERRAL_PROGRAM_REFERRALS_PATH}*`]: REFERRAL_PROGRAM_AFFILIATES_PATH,
    [`${REFERRAL_PROGRAM_MODELS_DEP_PATH}*`]: REFERRAL_PROGRAM_MODELS_PATH,
  }),

  /* Analytics */

  {
    exact: true,
    path: ANALYTICS_STATISTICS_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.Statistics),
    pageConfig: {
      title: 'statistics',
      category: ANALYTICS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: ANALYTICS_MEMBER_INSPECTOR_PATH,
    checkAccess: any(onlyRegularAffiliates, notPPStoForbiddenMemberInspector),
    component: getPageComponent(PAGES.MemberInspector),
    pageConfig: {
      title: 'memberInspector',
      category: ANALYTICS_CATEGORY_PATH,
    },
  },

  /* Overview */

  {
    exact: true,
    path: OVERVIEW_DASHBOARD_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.Dashboard),
    pageConfig: {
      title: 'dashboard',
      category: OVERVIEW_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: OVERVIEW_ACCOUNT_PATH,
    checkAccess: notLoggedToLogin,
    component: getPageComponent(PAGES.AccountSettings),
    pageConfig: {
      title: 'account',
      category: OVERVIEW_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: `${OVERVIEW_NEWS_PATH}${MAYBE_ENTITY_ID}`,
    checkAccess: commonAccessForStripchatScheme,
    component: getPageComponent(PAGES.NewsPage),
    pageConfig: {
      title: 'news',
      category: OVERVIEW_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: `${OVERVIEW_CPL_PATH}${PAGINATION}`,
    checkAccess: any(
      onlyRegularAffiliates,
      withoutAclToForbidden('cplAvailable'),
    ),
    component: getPageComponent(PAGES.Cpl),
    pageConfig: {
      title: 'cpl',
      category: OVERVIEW_CATEGORY_PATH,
    },
  },

  /* Links and craetives */

  {
    exact: true,
    path: LINKS_LINKS_BUILDER_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.LinksBuilder),
    pageConfig: {
      title: 'linksBuilder',
      category: LINKS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: LINKS_AD_CREATIVES_BUILDER_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.LandingPageBuilder),
    pageConfig: {
      title: 'adCreativesBuilder',
      category: LINKS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: `${LINKS_AD_CREATIVES_BUILDER_PATH}/:landingPageCode`,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.LandingPageBuilder),
    pageConfig: {
      title: 'adCreativesBuilder',
    },
  },
  {
    exact: true,
    path: LINKS_BANNERS_PATH,
    checkAccess: commonAccessForStripchatScheme,
    component: getPageComponent(PAGES.Banners),
    pageConfig: {
      title: 'banners',
      category: LINKS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: LINKS_PRE_ROLLS_PATH,
    checkAccess: commonAccessForStripchatScheme,
    component: getPageComponent(PAGES.PreRollsAds),
    pageConfig: {
      title: 'preRollAds',
      category: LINKS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: LINKS_SMART_LINK_PATH,
    checkAccess: any(smartLinkAccess, commonAccessForStripchatScheme),
    component: getPageComponent(PAGES.SmartPopundersList),
    pageConfig: {
      title: 'smartLink',
      category: LINKS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: `${LINKS_SMART_LINK_PATH}${ENTITY_ID}`,
    checkAccess: any(smartLinkAccess, commonAccessForStripchatScheme),
    component: getPageComponent(PAGES.SmartPopundersItem),
    pageConfig: {
      title: 'smartpopManagement',
    },
  },
  {
    exact: true,
    path: EASY_LINKS_PATH,
    checkAccess: commonAccessForStripchatScheme,
    component: getPageComponent(PAGES.EasyLinks),
    pageConfig: {
      title: 'easylinks',
      category: LINKS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: MODELS_TRAFFIC_PATH,
    checkAccess: notMediaBuyerStudioOrModelToDashboard,
    component: getPageComponent(PAGES.ModelsTraffic),
    pageConfig: {
      title: 'modelsTraffic',
      category: LINKS_CATEGORY_PATH,
    },
  },

  /* Whitelabels */

  {
    exact: true,
    path: WHITE_LABELS_CATEGORY_PATH,
    checkAccess: any(commonAccessForStripchatScheme, whiteLabelAccess),
    component: getPageComponent(PAGES.WhiteLabels),
    pageConfig: {
      title: 'whitelabels',
      category: WHITE_LABELS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: [
      `${WHITE_LABELS_CATEGORY_PATH}/new`,
      `${WHITE_LABELS_CATEGORY_PATH}${ENTITY_ID}`,
    ],
    checkAccess: any(commonAccessForStripchatScheme, whiteLabelAccess),
    component: getPageComponent(PAGES.WhiteLabel),
    pageConfig: {
      title: 'whitelabels',
    },
  },

  /* Payouts */

  {
    exact: true,
    path: `${PAYOUTS_PAYOUT_HISTORY_PATH}${PAGINATION}`,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.PayoutHistory),
    pageConfig: {
      title: 'payoutHistory',
      category: PAYOUTS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: PAYOUTS_PAYOUTS_SETUP_PATH,
    checkAccess: any(notLoggedToLogin, mediaBuyerStudioOrModelToModelsTraffic),
    component: getPageComponent(PAGES.PayoutSettings),
    pageConfig: {
      title: 'payoutSetup',
      category: PAYOUTS_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: EARNINGS_LOG_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.EarningsLog),
    pageConfig: {
      title: 'earningsLog',
      category: PAYOUTS_CATEGORY_PATH,
    },
  },

  /* Referral program */

  {
    exact: true,
    path: `${REFERRAL_PROGRAM_MODELS_PATH}${PAGINATION}`,
    checkAccess: any(
      notApprovedToAccount,
      internalSchemesToForbidden,
      mediaBuyerStudioOrModelToModelsTraffic,
      onlyAffiliatesWithStripchatScheme,
    ),
    component: getPageComponent(PAGES.Models),
    pageConfig: {
      title: 'referralModels',
      category: REFERRAL_PROGRAM_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: `${REFERRAL_PROGRAM_AFFILIATES_PATH}${PAGINATION}`,
    checkAccess: commonAccessForStripchatScheme,
    component: getPageComponent(PAGES.Referrals),
    pageConfig: {
      title: 'referralAffiliates',
      category: REFERRAL_PROGRAM_CATEGORY_PATH,
    },
  },

  /* Service */

  {
    exact: true,
    path: SERVICE_POSTBACK_SETUP_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.PostbackSettings),
    pageConfig: {
      title: 'postbackSetup',
      category: SERVICE_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: `${SERVICE_POSTBACKS_LOG_PATH}${PAGINATION}`,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.PostbacksLogs),
    pageConfig: {
      title: 'postbacksLog',
      category: SERVICE_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: SERVICE_SECRETS_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.Secrets),
    pageConfig: {
      title: 'secrets',
      category: SERVICE_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: SERVICE_API_DOMAIN_PATH,
    checkAccess: any(
      onlyRegularAffiliates,
      withAclToForbidden('modelsExtForbid'),
    ),
    component: getPageComponent(PAGES.ApiForDomain),
    pageConfig: {
      title: 'apiForDomain',
      category: SERVICE_CATEGORY_PATH,
    },
  },

  /* Documentation */

  {
    exact: true,
    path: DOCUMENTATION_LANDING_OPTIONS_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.LandingOptionsDocumentation),
    pageConfig: {
      title: 'landingOptions',
      category: DOCUMENTATION_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: DOCUMENTATION_LINKS_CREATIVES_PARAMS_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.CreatviesDocumentation),
    pageConfig: {
      title: 'linksAndAdCreativesParams',
      category: DOCUMENTATION_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: DOCUMENTATION_API_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.ApiDocumentation),
    pageConfig: {
      title: 'api',
      category: DOCUMENTATION_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: DOCUMENTATION_SCRIPTS_PATH,
    checkAccess: onlyRegularAffiliates,
    component: getPageComponent(PAGES.ScriptsDocumentation),
    pageConfig: {
      title: 'scripts',
      category: DOCUMENTATION_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: DOCUMENTATION_VIDEO_TUTORIALS_PATH,
    checkAccess: any(notLoggedToLogin, mediaBuyerStudioOrModelToModelsTraffic),
    component: getPageComponent(PAGES.VideoTutorials),
    pageConfig: {
      title: 'videoTutorials',
      category: DOCUMENTATION_CATEGORY_PATH,
    },
  },
  {
    exact: true,
    path: DOCUMENTATION_POSTBACK_PARAMS_PATH,
    checkAccess: any(
      notApprovedToAccount,
      mediaBuyerStudioOrModelToModelsTraffic,
    ),
    component: getPageComponent(PAGES.PostbacksDocumentation),
    pageConfig: {
      title: 'postbackParams',
      category: DOCUMENTATION_CATEGORY_PATH,
    },
  },
  // PLOP_APPEND_PAGE_ROUTE_CONFIG_PATTERN
];

export default MAIN_LAYOUT_ROUTES;
